import { FC, useEffect } from 'react'

import { useSelector } from 'react-redux'
import { Col, message } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { FullWideNotification } from 'src/Components/FullWideNotification'
import IconLinkExpired from 'src/Assets/Svg/icon-link-expired.svg?react'
import { getUser } from 'src/Redux/auth-process/userSlice/selectors'
import { sendQuickLoginLink } from 'src/Redux/auth-process/emailPasswordSlice/api-actions'
import { useAppDispatch } from 'src/Hooks/redux'
import { useQuickLoginUTMParameters } from 'src/Hooks/useQuickLoginUTMParameters'
import { CTAButton } from 'src/Components/Buttons/CTAButton'
import { PrimaryButton } from 'src/Components/Buttons/PrimaryButton'

import { Title, Body, ButtonWrapper, Container } from './style'

export enum ErrorPageTypeEnum {
  QuickLink = 'quick',
}

const ExpiredLinkPage: FC = () => {
  const theme = useTheme()
  const dispatch = useAppDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const navigate = useNavigate()
  const utmParameters = useQuickLoginUTMParameters()

  const user = useSelector(getUser)

  const queryParams = new URLSearchParams(location.search)
  const errorType = queryParams.get('type')
  const userEmail = queryParams.get('email')

  useEffect(() => {
    if (errorType === ErrorPageTypeEnum.QuickLink && user.id) {
      navigate('/')
    }
  }, [errorType, navigate, user.id])

  const handleSendEmail = (): void => {
    if (userEmail) {
      void dispatch(
        sendQuickLoginLink({
          email: userEmail,
          utmParameters,
        }),
      )
      void messageApi.open({
        content: (
          <FullWideNotification message='The new email was successfully sent. Please, open the link in the email you received from us.' />
        ),
        duration: 3,
        style: { backgroundColor: theme.color.brandGreen },
        icon: null,
      })
    }
  }

  return (
    <Container>
      {contextHolder}
      <Col>
        <Body>
          <IconLinkExpired />
          <Title>Link expired</Title>
          This login link is older than 24 hours. Request a new one to access
          your account.
          <ButtonWrapper>
            <CTAButton onClick={handleSendEmail}>Request new link</CTAButton>
            <PrimaryButton onClick={() => navigate('/')}>
              Back to log in
            </PrimaryButton>
          </ButtonWrapper>
        </Body>
      </Col>
    </Container>
  )
}

export default ExpiredLinkPage
